import { Identify } from '@amplitude/analytics-browser'
import { Entry } from '../../global'
import amplitudeModule from './amplitude'
import { StatusDashboardClient } from './client'
import { Action, Actor, buildEventName, Context, Namespace } from './event'

const amplitude = amplitudeModule.getClient()

const client: StatusDashboardClient = {
    entryStatus: null,
    identify(entry: Entry): void {
        const identifyEvent = new Identify()

        this.entryStatus = entry.status

        identifyEvent.set('status', entry.status)
        identifyEvent.set('external_id', entry.externalId)
        identifyEvent.set('entry_id', entry.id)
        identifyEvent.set('partner_type', entry.partnerType)
        identifyEvent.set('partner_name', entry.partnerName)

        amplitude.identify(identifyEvent)
        amplitude.setUserId(entry.submissionId)
    },
    track(actor: Actor, action: Action, context: Context = {}): void {
        amplitude.track(buildEventName(Namespace.StatusDashboard, actor, action), {
            ...context,
            status: this.entryStatus,
        })
    },
}

export default client
